// The signed-in user's identity for the board. Board identity is the stable user id (the same
// id auth publishes on window.userInfo and sends as X-ClientId); display names + avatars are
// resolved from the people directory at render time. currentUserName() is kept only for the few
// display fallbacks and @-mention text — never for identity matching (use currentUserId()).

interface CurrentUserInfo {
  id?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
}

declare const window: Window & { userInfo?: CurrentUserInfo };

// Stable id of the signed-in user, or "" when unknown (pre-auth / SSR). Use this for every
// identity comparison (assignee is-me, watcher, reaction-mine, comment-author).
export function currentUserId(): string {
  return window.userInfo?.id ?? "";
}

// Display name of the signed-in user ("FirstName LastName" → username → "You"). Display only —
// used for @-mention insertion text and as a directory fallback, not for matching.
export function currentUserName(): string {
  const info: CurrentUserInfo | undefined = window.userInfo;
  if (info) {
    const fullName: string = `${info.firstName ?? ""} ${info.lastName ?? ""}`.trim();
    if (fullName) return fullName;
    if (info.username) return info.username;
  }
  return "You";
}
